import { AdmPlan } from "@custom-types/base-types";
import { EntityCellParams } from "@components/common/data-grid/adm-data-grid-types";
import { ReactNode } from "react";
import {
  DataGridCell,
  getEntity,
} from "@components/common/data-grid/adm-data-grid-utils";
import { useAppSelector } from "@store/store-helper";
import { activeTokensSelector } from "@store/plans/plans-selector";
import { formatLimitType } from "@utils/limit-data-display";
import { NumberUtils } from "@stellar/utils";

/**
 * Shows the tokens a plan currently grants, which are held by the token plans attached to it
 * rather than by the plan itself. Nothing is shown for a plan without active token plans.
 */
export function DataGridTokenCell(
  params: EntityCellParams<AdmPlan>
): ReactNode {
  const plan = getEntity(params);
  const activeTokens = useAppSelector(activeTokensSelector(plan.id));

  if (!activeTokens) {
    return null;
  }

  return (
    <DataGridCell
      content={`${NumberUtils.formatNumberWithSpaces(
        activeTokens.consumed
      )} | ${NumberUtils.formatNumberWithSpaces(
        activeTokens.total
      )} ${formatLimitType("CREDITS", activeTokens.total)}`}
    />
  );
}
